/**
 * @generated SignedSource<<5083cba0c436b392efd1e9c72635a3e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PaymentMethodTypeV2 = "ACH_BANK_ACCOUNT" | "APPLE_PAY" | "ARGENTINE_BANK_ACCOUNT" | "BANCOMAT_PAY" | "BLIK" | "CAD_WIRE" | "DENEB_IMPS" | "DENEB_UPI" | "DIRECT_DEPOSIT_ACCOUNT" | "EFT" | "FEDWIRE" | "FIAT_ACCOUNT" | "GIFTCARD" | "GOOGLE_PAY" | "IDEAL_BANK_ACCOUNT" | "INDIA_BANK_ACCOUNT" | "INDIA_UPI" | "INTERAC" | "MB_WAY" | "OPEN_BANKING" | "PAYMENT_METHOD_TYPE_UNKNOWN" | "PAYPAL_ACCOUNT" | "PIX" | "PIX_DEPOSIT" | "PIX_WITHDRAWAL" | "QD" | "REMITLY" | "RTP" | "SAMSUNG_PAY" | "SEPA_BANK_ACCOUNT" | "SEPA_V2" | "SG_FAST" | "SG_PAYNOW" | "SIC" | "SOFORT" | "SWIFT_BANK_ACCOUNT" | "TRUSTLY" | "UK" | "UK_BANK_ACCOUNT" | "WORLDPAY_CARD" | "ZENGIN_DEPOSIT" | "ZENGIN_DEPOSIT_V2" | "ZENGIN_WITHDRAWAL" | "ZENGIN_WITHDRAWAL_V2" | "ZEPTO" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type getIsCountryAllowedFiatFragment$data = {
  readonly instantBuy: boolean;
  readonly pickerData: {
    readonly __typename: "BankPickerDataV2";
    readonly __typename: "BankPickerDataV2";
  } | {
    readonly __typename: "WorldpayCardPickerData";
    readonly use3ds: boolean;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly type: PaymentMethodTypeV2;
  readonly " $fragmentType": "getIsCountryAllowedFiatFragment";
};
export type getIsCountryAllowedFiatFragment$key = {
  readonly " $data"?: getIsCountryAllowedFiatFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getIsCountryAllowedFiatFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getIsCountryAllowedFiatFragment"
};

(node as any).hash = "8db115bc9554ca78c50e22c4d5e7ccc2";

export default node;
